import React from 'react'
import {withStyles} from 'material-ui'
import classNames from 'classnames'

import MainNav from '../MainNav'


const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        minHeight: theme.layout.heroTotalHeight,
        padding: "0 20px",
    },
    heroContent: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
    },
})

export const LandingHero = withStyles(styles)(
    ({classes, className='', children}) => (
        <section className={classNames(classes.root, className)}>
            <MainNav/>
            <div className={classes.heroContent}>
                {children}
            </div>
        </section>
    )
)




// WEBPACK FOOTER //
// ./src/components/landinglib/LandingHero.jsx